import React, { useEffect, useState } from "react";
import { appLogger } from "../../utils";
import Manage from "./manage";

const ArticlesContent = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "ArticlesContent",
      component: "ArticlesContent",
      fileName: "index.tsx",
      props: props,
    },
  });
  // const [open, setOpen] = useState(false);
  const { addOpen } = props;
  // useEffect(() => {
  //   setOpen(props.addOpen);
  // }, [props]);
  return <Manage addOpen={addOpen} setClosePopup={props.setClosePopup} />;
};

export default ArticlesContent;
